module.exports = __webpack_public_path__ + "img/logo_kibon.f37eca2c.png";